import { c as _c } from "react/compiler-runtime";
import useMobileLayout from '@/hooks/use-mobile-layout';
type MobileSidebarBackdropProps = {
  open: boolean;
  onClose: () => void;
};

// On mobile the sidebar overlays the document, so tapping the document closes it. Hidden from
// assistive tech and the tab order because the document title's toggle is the accessible control.
const MobileSidebarBackdrop = t0 => {
  const $ = _c(2);
  const {
    open,
    onClose
  } = t0;
  const isMobile = useMobileLayout();
  if (!isMobile || !open) {
    return null;
  }
  let t1;
  if ($[0] !== onClose) {
    t1 = <button type="button" aria-hidden={true} tabIndex={-1} className="absolute inset-0 z-[5] bg-(--overlay-backdrop)" onClick={onClose} />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MobileSidebarBackdrop;